import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { NavLink as RouterLink } from 'react-router-dom';
// @mui
import { Box, List, ListItemText, Collapse, ListItemButton } from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
//
import { StyledNavItem, StyledNavItemIcon } from './styles';
import { LightTooltip } from '../custom-components/custom-tooltip';

// ----------------------------------------------------------------------

NavSection.propTypes = {
  data: PropTypes.array,
  isCollapsed: PropTypes.bool,
};

export default function NavSection({ data = [], isCollapsed, ...other }) {
  return (
    <Box {...other}>
      <List disablePadding sx={{ pr: 1 }}>
        {data.map((item) => (
          <NavItem key={item.title} item={item} isCollapsed={isCollapsed} />
        ))}
      </List>
    </Box>
  );
}

NavItem.propTypes = {
  item: PropTypes.object,
};

function NavItem({ item }) {
  const { title, path, icon, info, children } = item;
  const [open, setOpen] = useState(false);

  const isPracticeInfoDisabled = localStorage.getItem('practiceInfo') === 'false';

  const handleClick = () => {
    if (children) {
      setOpen(!open);
    }
  };

  const navItem = (
    <StyledNavItem
      component={children ? 'div' : RouterLink}
      to={children ? undefined : path}
      onClick={children ? handleClick : undefined}
      sx={{
        '&.active': {
          color: 'white',
          bgcolor: '#5E69F4',
          fontWeight: 'fontWeightBold',
        },
        cursor: children ? 'pointer' : 'default',
      }}
      disabled={title === 'Practice Information' && isPracticeInfoDisabled}
    >
      <StyledNavItemIcon>{icon && icon}</StyledNavItemIcon>
      <ListItemText disableTypography primary={title} />
      {children && (open ? <ExpandLess /> : <ExpandMore />)}
      {info && info}
    </StyledNavItem>
  );

  return (
    <div>
      {title === 'Practice Information' && isPracticeInfoDisabled ? (
        <LightTooltip title="Sign contract first">
          <span>{navItem}</span>
        </LightTooltip>
      ) : (
        <>
          {navItem}
          {children && (
            <Collapse in={open} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {children.map((child) => (
                  <ListItemButton
                    key={child.title}
                    component={RouterLink}
                    to={child.path}
                    sx={{
                      pl: 2,
                      fontSize: '13px',
                      color: 'text.secondary',
                      '&.active': {
                        color: 'white',
                        bgcolor: '#5E69F4',
                        fontWeight: 'fontWeightBold',
                      },
                    }}
                  >
                    <StyledNavItemIcon>{child.icon && child.icon}</StyledNavItemIcon>
                    <ListItemText disableTypography primary={child.title} />
                  </ListItemButton>
                ))}
              </List>
            </Collapse>
          )}
        </>
      )}
    </div>
  );
}
